import type { CanvasElement } from '@/components/canvas/document/publicTypes';
import { type BaseElementConfig, createBase } from '../../registry/factoryShared';

export function createCircleElement(config: BaseElementConfig): CanvasElement<'circle'> {
  return { ...createBase('circle', config), data: {} };
}
